<template>
  <c-form-group :id="id"
                v-slot="{ valid, errors, required, reset, invalid, dirty }"
                :form-group-class="formGroupClass"
                :inline="inline"
                :input-wrapper-class="inputWrapperClass"

                :label="label"
                :label-class="labelClass"
                :label-invisible="labelInvisible"
                :label-right="labelRight"

                :validate-custom-messages="validateCustomMessages"
                :validate-disabled="validateDisabled"
                :validate-rules="validateRules"
                :validate-vid="validateVid"
  >
    <b-form-datepicker :id="id"
                       v-bind="$attrs"
                       :state="validateRules ? errors[0] ? false : (dirty && invalid ? false : null) : null"
                       :value="value"
                       class="mb-2"
                       label-current-month="Tháng hiện tại"
                       label-help="Dùng phím mũi tên để chọn ngày"
                       label-next-month="Tháng sau"
                       label-next-year="Năm sau"
                       label-no-date-selected="Chưa chọn ngày"
                       label-prev-month="Tháng trước"
                       label-prev-year="Năm trước"
                       label-today-button="Chọn ngày hôm nay"
                       locale="vi-VN"
                       value-as-date
                       @input="onInput"
    />
    <b-form-invalid-feedback v-if="errors[0]" style="cursor: pointer" @click="reset()">* {{ errors[0] }}</b-form-invalid-feedback>
  </c-form-group>
</template>

<script>
import formGroupMixins from "@/mixins/formGroupMixins";

export default {
  name: "CDatePicker",
  mixins: [
    formGroupMixins
  ],
  props: {
    value: Date
  },
  data() {
    return {
      id: null
    }
  },
  methods: {
    onInput(newValue) {
      this.$emit('input', newValue);
    },
  },
  mounted() {
    this.id = 'formDate' + this._uid;
  }

}
</script>

<style scoped>

</style>